module.exports = __webpack_public_path__ + "static/media/JoshNkoyHeadshot.84bd4aa9.jpg";